// Module
var code = "<h3>Reports</h3> ";
// Exports
export default code;